module.exports = __webpack_public_path__ + "img/msg.f268b714.png";